export const determineTableSubheaderRowBackgroundColor = (itemIsSelected: boolean): string => {
  return itemIsSelected ? 'rgba(148, 148, 203, 0.31)' : '';
};
